module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/faef218a10693525eaa087f8c26fe2aa.png";